import { ELinkIcons } from '@consts';

import {
  EmailIcon,
  GithubIcon,
  LinkedinIcon,
  TelegramIcon,
} from '@assets/icons';

import { ContactIconProps } from './ContactIcon.types';

export const ContactIcon = ({ type }: ContactIconProps) => {
  switch (type) {
    case ELinkIcons.email:
      return <EmailIcon />;
    case ELinkIcons.github:
      return <GithubIcon />;
    case ELinkIcons.telegram:
      return <TelegramIcon />;
    default:
      return <LinkedinIcon />;
  }
};
